<mat-table [dataSource]="filteredData" matSort aria-label="Document List">
  <!-- column definitions -->
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i">
    <mat-header-cell
      mat-sort-header
      *matHeaderCellDef
      [disabled]="!columnConfig[i].sort"
      [class.is-select-column]="columnConfig[i].key === 'select'"
      [class.is-icon-column]="
        columnConfig[i].key === 'icon' || columnConfig[i].key === 'isLocked' || columnConfig[i].key === 'deleteIcon'
      "
    >
      <ng-container *ngIf="columnConfig[i].key !== 'select'">
        {{ columnConfig[i].label }}
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'select'">
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </ng-container>
    </mat-header-cell>

    <mat-cell
      *matCellDef="let cell; index as j"
      [class.is-linkable]="columnConfig[i].linkable"
      [class.is-select-column]="columnConfig[i].key === 'select'"
      [class.is-icon-column]="
        columnConfig[i].key === 'icon' || columnConfig[i].key === 'isLocked' || columnConfig[i].key === 'deleteIcon'
      "
    >
      <ng-container *ngIf="columnConfig[i].key === 'select'">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selectionChanged($event, cell) : null"
          [checked]="selection.isSelected(cell)"
        >
        </mat-checkbox>
      </ng-container>
      <ng-container
        *ngIf="
          columnConfig[i].key !== 'select' &&
          columnConfig[i].key !== 'icon' &&
          columnConfig[i].key !== 'isLocked' &&
          columnConfig[i].key !== 'documentTypeDescription' &&
          ['eo'].includes(this.globals.catchment)
        "
      >
        {{ cell[column] }}
      </ng-container>
      <ng-container
        *ngIf="
          columnConfig[i].key !== 'select' &&
          columnConfig[i].key !== 'icon' &&
          columnConfig[i].key !== 'isLocked' &&
          columnConfig[i].key !== 'documentSectionDescription' &&
          ['wc'].includes(this.globals.catchment)
        "
      >
        {{ cell[column] }}
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'icon'">
        <fa-icon [icon]="cell[column]"></fa-icon>
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'deleteIcon'">
        <a *ngIf="!isReadOnly" href="javascript: void(0);" aria-label="Delete document" (click)="deleteDocument(cell.parentDocumentStoreKey)">
          <fa-icon [icon]="deleteIcon" class="red"></fa-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'isLocked'">
        <div class="lock-icon">
          <a href="javascript: void(0);" [attr.aria-label]="cell['isLink']?'View Document':'Edit Document'" (click)="viewEditDocument(cell.parentDocumentStoreKey)">
            <ng-container *ngIf="cell['isLink']">
              <fa-icon [icon]="linkIcon"></fa-icon>
            </ng-container>
            <ng-container *ngIf="!cell['isLink']">
              <fa-icon [icon]="lockOpenIcon" *ngIf="!cell[column]"></fa-icon>
              <fa-icon
                [icon]="lockIcon"
                *ngIf="cell[column]"
                (click)="viewEditDocument(cell.parentDocumentStoreKey)"
              ></fa-icon>
            </ng-container>
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'documentTypeDescription'">
        <!-- keys >=1 are generated in the backend. Keys < 1 are generated temporarily in the front-end -->
        <span *ngIf="cell.parentDocumentStoreKey < 1">{{ cell[column] }}</span>
        <a *ngIf="cell.parentDocumentStoreKey >= 1" (click)="downloadDoc(cell.parentDocumentStoreKey)">{{
          cell[column]
        }}</a>
      </ng-container>
      <ng-container *ngIf="columnConfig[i].key === 'documentSectionDescription'">
        <!-- keys >=1 are generated in the backend. Keys < 1 are generated temporarily in the front-end -->
        <span *ngIf="cell.parentDocumentStoreKey < 1">{{ cell[column] }}</span>
        <a *ngIf="cell.parentDocumentStoreKey >= 1" (click)="downloadDoc(cell.parentDocumentStoreKey)">{{
          cell[column]
        }}</a>
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Header Row-->
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>

  <!-- Select Record -->
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>

<!-- No data found -->
<ng-container *ngIf="isReady && filteredData.length < 1">
  <div class="noresult">
    <div class="center">No results found</div>
  </div>
</ng-container>